import { CONSENT_VERSION, isValidEmail, type ConsentBody } from '@akrababul/shared';
import { qs } from '../lib/dom.js';
import { authClient } from '../lib/auth-client.js';
import { reportError } from '../lib/report-error.js';
import { redirectIfLoggedIn } from '../lib/session-guard.js';
import { captchaToken, resetCaptcha } from '../lib/captcha.js';
import { signupErrorMessage } from '../lib/auth-errors.js';
import { showInAppBrowserWarning } from '../lib/in-app-browser.js';

void redirectIfLoggedIn('/akrabalarim.html');
showInAppBrowserWarning(qs('#browser-uyari'));

// Turnstile site anahtarı build sırasında HTML'e gömülür (%VITE_TURNSTILE_SITE_KEY%); betik otomatik render eder.
const form = qs<HTMLFormElement>('#f'), err = qs('#err');
const show = (m: string) => { err.textContent = m; err.classList.remove('hidden'); };
const consented = () => qs<HTMLInputElement>('#c1').checked && qs<HTMLInputElement>('#c2').checked && qs<HTMLInputElement>('#c3').checked;
const PRIVACY_FLAGS = ['nameHidden', 'ageHidden', 'photoHidden', 'cityHidden'] as const;
const privacy = () => Object.fromEntries(PRIVACY_FLAGS.map((f) => [f, qs<HTMLInputElement>(`#${f}`).checked]));

form.addEventListener('submit', async (e) => {
  e.preventDefault(); err.classList.add('hidden');
  if (!consented()) return show('Devam etmek için üç onay kutusunu da işaretleyin.');
  const email = qs<HTMLInputElement>('#email').value.trim();
  if (!isValidEmail(email)) return show('Geçerli bir e-posta adresi yazın.');
  const pw = qs<HTMLInputElement>('#pw').value;
  if (pw.length < 8) return show('Şifre en az 8 karakter olmalı.');
  if (pw !== qs<HTMLInputElement>('#pw2').value) return show('Şifreler birbiriyle aynı değil.');
  const token = captchaToken(); if (!token) return show('Lütfen robot olmadığınızı doğrulayın.');
  const btn = qs<HTMLButtonElement>('button[type=submit]'); btn.disabled = true;
  // Gizleme anahtarları kayıt anında yazılır; Google ile girişte varsayılan (hiçbiri gizli değil) kalır, Ayarlar'dan değiştirilir.
  // Onaylar sunucuya gönderilir ve orada zorunludur; kutuların işaretli olması tek başına kanıt değil.
  const consent: ConsentBody = { version: CONSENT_VERSION, privacy: true, transfer: true, terms: true };
  const { error } = await authClient.signUp.email({
    email, password: pw, name: 'Yeni üye',
    ...privacy(), consent,
    callbackURL: '/yukle.html', fetchOptions: { headers: { 'x-captcha-response': token } },
  } as Parameters<typeof authClient.signUp.email>[0]);
  btn.disabled = false;
  if (error) {
    resetCaptcha();
    reportError('other', new Error(error.message ?? 'signup'), { step: 'signup', status: error.status ?? 0 });
    return show(signupErrorMessage(error.status ?? 0, error.message ?? ''));
  }
  // Doğrulama sayfası: spam klasörü uyarısı ve 2 dakikalık yeniden gönderme bekleme süresi orada gösterilir
  window.location.href = '/dogrulama.html?sent=1&email=' + encodeURIComponent(email);
});
qs('#google').addEventListener('click', async () => {
  if (!consented()) return show('Devam etmek için üç onay kutusunu da işaretleyin.');
  await authClient.signIn.social({ provider: 'google', callbackURL: '/yukle.html' });
});
